const newsletterRoots = document.querySelectorAll("[data-newsletter]");

newsletterRoots.forEach((root) => {
  const input = root.querySelector(".sp-newsletter__input");
  const submit = root.querySelector(".sp-newsletter__submit");

  if (!input || !submit) return;

  const updateSubmitState = () => {
    submit.classList.toggle(
      "sp-newsletter__submit--active",
      input.value.trim() !== "",
    );
  };

  input.addEventListener("input", updateSubmitState);
  updateSubmitState();
});
